import { React } from "react";

import GetUserDetails from "../../../../base/GetUserDetails.component";

const VerifyInsuranceDialog = ({ onClose }) => {
  return <GetUserDetails onClose={onClose} />;
};

export default VerifyInsuranceDialog;
